import type { GenerationKind } from '../domain/schemas';
import { GENERATION_KIND_LABELS } from '../providers/types';
import { useServices } from '../state/services';

/** Shows each generation capability and whether a provider is configured. */
export function ProviderStatusList({ kinds }: { kinds?: GenerationKind[] }) {
  const { registry } = useServices();
  const providers = registry.list().filter((p) => !kinds || p.capabilities.kinds.some((k) => kinds.includes(k)));
  return (
    <ul className="divide-y divide-zinc-800" aria-label="Generation providers">
      {providers.map((provider) => {
        const availability = provider.availability();
        const available = availability.state === 'available';
        return (
          <li key={provider.capabilities.providerId} className="flex flex-wrap items-start justify-between gap-2 py-2.5">
            <div className="min-w-0">
              <p className="text-sm font-medium text-zinc-100">
                {provider.capabilities.kinds.map((k) => GENERATION_KIND_LABELS[k]).join(', ')}
              </p>
              <p className="text-xs text-zinc-400">
                {available
                  ? `${provider.capabilities.displayName} — runs locally in your browser.`
                  : availability.reason}
              </p>
            </div>
            <span
              data-testid={`provider-${provider.capabilities.providerId}`}
              className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${
                available ? 'bg-emerald-900/60 text-emerald-200' : 'bg-zinc-800 text-zinc-400'
              }`}
            >
              {available ? 'Available' : 'Not configured'}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
